module.exports = __webpack_public_path__ + "img/header_search_grey.1ea07ff8.svg";